import React from 'react';

import Icon from '../Icon/Icon';

const RegularCleaningIcon = (props) => {
    return (
        <Icon width='64' height='64' fill='none' {...props}>
            <path
                d='M25 9.55524C25 9.17559 25.2132 8.82417 25.5641 8.67913C26.6228 8.24148 27.7832 8 29 8H32C37.5228 8 42 12.4772 42 18V46C42 51.5229 37.5228 56 32 56H29C27.7832 56 26.6228 55.7585 25.5641 55.3209C25.2132 55.1758 25 54.8244 25 54.4448V54.0765C22.4122 53.4104 20.5 51.0613 20.5 48.2655L20.5 16C20.5 13.2042 22.4122 10.8551 25 10.189V9.55524Z'
                fill='#393E44'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M23.5 10.8026C23.9643 10.5341 24.4678 10.3259 25 10.189L25 54.0764C24.4678 53.9395 23.9643 53.7313 23.5 53.4628L23.5 10.8026Z'
                fill='#FFFDFB'
            />
            <path fillRule='evenodd' clipRule='evenodd' d='M23.5 41H20.5V39H23.5V41Z' fill='#00D1D2' />
            <path
                d='M12.0039 19.6851C12.7666 21.2666 13.3436 21.882 15.0072 22.6884C13.3436 23.5745 12.7089 24.1708 12.0039 25.6917C11.3095 24.2066 10.6625 23.5409 9.0006 22.6884C10.6702 21.9397 11.228 21.2858 12.0039 19.6851Z'
                fill='#393E44'
            />
            <path
                d='M13.6455 39.0288C14.7662 41.3526 15.614 42.2569 18.0583 43.4417C15.614 44.7437 14.6814 45.6198 13.6455 47.8545C12.6251 45.6725 11.6745 44.6943 9.23267 43.4417C11.6859 42.3417 12.5054 41.3809 13.6455 39.0288Z'
                fill='#00D1D2'
            />
            <path
                d='M47.459 15.4746C48.2376 19.1812 49.2511 20.4509 53.2012 21.2168C49.344 22.2909 48.1872 23.4851 47.459 26.959C46.7206 23.5318 45.4605 22.282 41.7168 21.2168C45.6224 20.4895 46.6572 19.2251 47.459 15.4746Z'
                fill='#00D1D2'
            />
            <path
                d='M47.6602 41.5C47.9538 44.9122 48.8115 45.9128 52.3197 46.1596C49.1528 47.0941 48.1732 48.023 47.6602 50.8192C47.2512 48.0325 46.245 46.9908 43.0006 46.1596C46.2742 45.711 47.1499 44.7116 47.6602 41.5Z'
                fill='#393E44'
            />
        </Icon>
    );
};

export default RegularCleaningIcon;
